import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HaRolemanagementserviceService } from '../../services/HaRoleManagement.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-ha-create-role',
  templateUrl: './ha-create-role.component.html',
  styleUrls: ['./ha-create-role.component.css']
})

export class HaCreateRoleComponent implements OnInit {
  roleList: any[]=[];
  tempRoleList: any[] = [];
  groupList: any[]=[];
  elementDownSide: HTMLElement;
  elementUpSide: HTMLElement;
  roleIdPopUpValue: string = '';
  roleNamePopUpValue: string = '';
  elementAssigned: HTMLElement;
  elementDoctorList: HTMLElement;
  page: number = 1;
  assignedFunctionList: any[];
  searchTextEmpty: string = '';
  searchTerm: string = '';
  roleIdSelected;
  unAssignedUserList: any[];
  showOverlayRole: boolean;
  showAssignedList: boolean;
  showAssignedUsers: boolean;
  roleIdforAssign;
  patientListShow: boolean;
  doctorList: any[];
  assignedListShow: boolean;
  modalElement: HTMLElement;
  elementSlide: HTMLElement;
  functionList: any[];
  roleId: string;
  isChecked: boolean;
  listView: boolean = false;
  mainViewError = new ErrorModel();
  userFunctionError = new ErrorModel();
  userError = new ErrorModel();

  constructor(private route: Router, private _service: HaRolemanagementserviceService) {

  }

  ngOnInit() {
    this.getRoles();
    this.elementDoctorList = document.getElementById('showdoctor');
  }

  getRoles() {
    this.showOverlayRole = true;
    this.mainViewError.display = false;
    this.elementDownSide = document.getElementById('downsidediv');
    this.elementUpSide = document.getElementById('upsidediv');

    this._service.getRoles().subscribe((data) => {
      this.roleList = data['roles'];
      this.tempRoleList = data['roles'];
      this.groupList = data['groups'];

        if (this.roleList.length <= 0) {
          this.elementDownSide.style.display = 'none';
          this.elementUpSide.style.display = 'block';
        } else {
          this.elementDownSide.style.display = 'block';
          this.elementUpSide.style.display = 'none';
        }

    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayRole = false;

    });
  }


  // code to insert selected function
  insertSelectedMenuItems(event, menuId) {
    this.isChecked = event.target.checked;
    this._service.insertSelectedMenuItems(this.roleId, menuId, this.isChecked).subscribe(
    (data: any[]) => {

      AlertMessages.Show(this.isChecked ? 'Assigned' : 'De-Assignment', this.isChecked ? 'Assigned Function' : 'De-Assigned Function', AlertType.Success);
      this.showAssignedFunctions(this.roleId, 1, '');
      this.getRoles();
    },
    (error) => {
      AlertMessages.Show('Failed','could not perform action',AlertType.Error);
      this.showAssignedFunctions(this.roleId, 1, '');
    });
  }

  alertClose() {
    setTimeout(() => {
      this.getRoles();
    }, 2000);
  }

  onEventRoute(event, roleId, roleName) {
    event.stopPropagation();
    this.routeToRole(roleId, roleName);
  }

  //code to route to create role component
  routeToRole(roleId, roleName) {
    this.route.navigate(['Hospital/HAAdmin/haRoleview'], {
      queryParams: {
        'Role_id': roleId,
        'Role_name': roleName
      }
    });
  }

  //code to create role
  insertRole(text, groupId) {
    if (groupId == '' || text == '') {
      alert('Add Required Field');
    } else {
      var indexVal = this.roleList.filter(i => i.roleName.toLowerCase().trim() == text.toLowerCase().trim())[0];
      if (indexVal !== undefined) {
        this.cleanUpOnInsertingRoleFlow();
        AlertMessages.Show('Warning', 'Role Name Already Exists!!!', AlertType.Warning);
      } else {
        this._service.insertRole(text, groupId).subscribe((data) => {
          AlertMessages.Show('Success', data['StatusMessage'], AlertType.Success);
        },
        (error) => {
          AlertMessages.Show('Failed', 'Could not add role!', AlertType.Error);
        }).add(() => {
          this.cleanUpOnInsertingRoleFlow();
        });
      }
    }
  }

  // code to display the list of assigned function and user to the selected role
  showAssignedFunctions(roleId, pageNo, text) {
    this.showAssignedList = true;
    this.showAssignedUsers = true;
    this.userFunctionError.display = false;
    this.roleId = roleId;
    this.elementDoctorList = document.getElementById('showdoctor');
    this.elementDownSide.style.display = 'block';
    this.elementUpSide.style.display = 'none';
    this.searchTextEmpty = '';
    this.roleIdSelected = roleId;
    this.resetBorder();
    let index = this.roleList.findIndex(role => role.id == roleId);
    this.roleList[index].border = '2px solid #0969c9';
    this.roleList[index].borderBottom = '2px solid #0969c9';
    this._service.getMenuItems(roleId).subscribe((data: any[]) => {
      this.functionList = data;
      this.assignedFunctionList = data.filter(item => item.isChecked == true);
      this.showAssignedList = false;
      this.assignedListShow =  this.functionList.length <= 0 ? true : false;
    },
    (error) => {
      this.userFunctionError.error = error;
      this.userFunctionError.display = true;
    }).add(() => {
      this.showAssignedList = false;
      this.showSearchResult(roleId, pageNo, text, false);

    });

  }

  resetBorder() {
    for (let roles of this.roleList) {
      roles.border = '';
      roles.borderBottom = '';
    }
  }

  showSearchResult(roleId,pageNo,text,type) {
    this.userError.display = false;
    if (type) this.showAssignedUsers = true;
    this._service.getUsersByRole(type ? this.roleIdSelected : roleId, pageNo, text.trim()).subscribe(
    (data: any[]) => {
      this.elementDoctorList.style.display = 'block';
      this.doctorList = data;
      this.page = 1;
      this.patientListShow = this.doctorList.length <= 0 ? true : false;
    },
    (error) => {
      this.userError.error = error;
      this.userError.display = true;
    }).add(() => {
      this.showAssignedUsers = false;
    });
  }

  openNav(roleId, pageNo, searchText) {
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = '0px';
    this.elementSlide.style.opacity = '1';
    this.showAssignedFunctions(roleId, pageNo, searchText);
  }

  closeNav() {
    for (let roles of this.roleList) {
      roles.backgroundColor = 'rgb(247, 247, 247)';
    }

    this.resetBorder();
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = '-105%';
    this.elementSlide.style.opacity = '0';
  }

  onEventSlide(obj) {
    obj.evt.stopPropagation();
    this.openNav(obj.roleId, obj.pageNo, obj.searchText);
  }

  // code for infinite scroll i.e loading data on scroll so as to reduce load time
  onScroll(text) {
    this.showAssignedUsers = true;
    this.page = this.page + 1;
    this._service.getUsersByRole(this.roleIdSelected, this.page, text).subscribe(
    (data: any[]) => {
      if (data != undefined) {
        data.forEach(item => {
          this.doctorList.push(item);
        });
      }

    },
    (error) => {
      this.page = this.page - 1;
      AlertMessages.Show('Failed','Could not load!',AlertType.Error);
    }).add(() => {
      this.showAssignedUsers = false;

    });
  }


  filterList(val) {
    if (val == '-') {
      this.roleList = this.tempRoleList;
    } else {
      this.roleList = this.tempRoleList.filter(i => i.groupId == val);
    }
  }

  cleanUpOnInsertingRoleFlow() {
    this.roleIdPopUpValue = '';
    this.roleNamePopUpValue = '';
    this.getRoles();
    this.alertClose();
  }
}
